.controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.buttons {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.info {
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 8px;
}

.infoSpacer {
  margin-left: 8px;
}
